import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as supportedEvents from '../../util/supportedEvents';

export default class TooltipTarget extends React.Component {
  static propTypes = {
    in: PropTypes.func.isRequired,
    out: PropTypes.func.isRequired,
    children: PropTypes.node,
    hover: PropTypes.bool,
  };

  render() {
    return (
      <div
        className={classNames(
          this.props.hover && 'tooltip-hover',
          'tooltip-target'
        )}
        onPointerEnter={
          supportedEvents.POINTER_SUPPORT && !supportedEvents.TOUCH_SUPPORT
            ? event => this.props.in()
            : null
        }
        onMouseEnter={
          supportedEvents.MOUSE_SUPPORT && !supportedEvents.TOUCH_SUPPORT
            ? event => this.props.in()
            : null
        }
        onPointerLeave={
          supportedEvents.POINTER_SUPPORT && !supportedEvents.TOUCH_SUPPORT
            ? this.props.out
            : null
        }
        onMouseLeave={
          supportedEvents.MOUSE_SUPPORT && !supportedEvents.TOUCH_SUPPORT
            ? this.props.out
            : null
        }
      >
        {this.props.children}
      </div>
    );
  }
}
